var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.333l3.667 9.166H16.87L15.87 15h-3.408l-1 2.5H9.668l3.666-9.166H15zm-.833 2.404l-1.04 2.596h2.077l-1.037-2.596z",
    fill: "#AFB7C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#222B40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.167 12.5v1.666a1.667 1.667 0 001.541 1.662l.125.005h2.5v1.666h-2.5A3.333 3.333 0 012.5 14.166v-1.667h1.667zm10-10A3.333 3.333 0 0117.5 5.832v1.666h-1.667V5.833a1.667 1.667 0 00-1.666-1.667h-2.5V2.499h2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.667 1.666v1.667H10v5.833H6.667v2.5H5v-2.5H1.667V3.333H5V1.666h1.667zM5 4.999H3.333v2.5H5V5zm3.333 0H6.667v2.5h1.666V5z"
  }))));
}
export default SvgZh;